<div class="quarterly-feedback-container">
  <emerald-tab-bar [tabsData]="tabsData" class="custom-green" [showContent]="true"
                   (selectedTabChange)="onTabChange($event)"></emerald-tab-bar>

  <div *ngIf="(selectedTab?.label ?? '') === tabLabels.Compliance">
    <div class="compliance-section">
      <div class="rto-compliance-card">
        <h3>{{ VendorProfile.rtoCompliance }}</h3>
        <app-rto-bar-chart [vendorId]="vendorId"></app-rto-bar-chart>
        <div class="legend">
          <span class="compliant-dot"></span> Compliant
          <span class="non-compliant-dot"></span> Non Compliant
        </div>
      </div>
      <div class="general-compliance-card">
        <div class="header">
          <h3>{{ VendorProfile.generalCompliance }}</h3>

          <div class="filter">
            <div class="fs-field">
              <span class="fs-label">Quarter</span>
              <select class="native-select has-icon icon-cal" aria-label="Quarter" (change)="onQuarterChange($any($event.target).value)">
                <option *ngFor="let o of monthOptions" [value]="o.label" [selected]="o.value === preSelectedValue">{{ o.label }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="items-container">
          <div class="item" *ngFor="let item of generalComplianceCards">
            <div class="label-row">
              <span class="label">{{ item.label }}</span>
                <a (click)="downloadFile(item.fileUrl, item.label); $event.preventDefault()">
                <img class="logo" src="../../../../../assets/icons/excel.svg" alt="Download Excel" />
              </a>
            </div>
            <span class="value" [class.red]="item.highlight">{{ item.value }}</span>
          </div>
        </div>
      </div>
      <div class="spacer"></div>
    </div>
  </div>
  <div *ngIf="(selectedTab?.label ?? '') === tabLabels.PeopleMetrics">
    <div class="placeholder-tab-content">
      <app-people-metrics [fieldVisibility]="fieldVisibility" [vendorId]="vendorId"></app-people-metrics>
    </div>
  </div>
  <div *ngIf="(selectedTab?.label ?? '') === tabLabels.LearningDevelopment">
    <div class="placeholder-tab-content"><app-learning-development [persona]="personaType" [vendorId]="vendorId"></app-learning-development></div>
  </div>
  <div *ngIf="(selectedTab?.label ?? '') === tabLabels.StrategicPartnership">
    <div class="placeholder-tab-content"><app-strategic-partnership [vendorId]="vendorId"></app-strategic-partnership></div>
  </div>
</div>
